// TODO nullable 방지로 기본값 NONE
export enum BusinessType {
  COMPANY = 'COMPANY',
  PERSONAL = 'PERSONAL',
  NONE = 'NONE',
}
